import { ActionTree } from 'vuex';
import { PostgradEarlyGraduationEligibilityState } from './state';
import RootState from '@/store/root_state';
import { getChimeraToken } from '@/helpers/get-tokens';
import EarlyGraduationService from '@/helpers/postgradEarlyGraduation/request';

const actions: ActionTree<PostgradEarlyGraduationEligibilityState, RootState> = {
  async GET_POSTGRAD_EARLY_GRADUATION_ELIGIBILITY_FOR_COURSE({ commit }, courseId: number) {
    const token = getChimeraToken();

    if (!token || !courseId) return;

    const eligibility = await EarlyGraduationService.getCourseEligibility(
      token,
      courseId.toString(),
    );

    commit('SET_POSTGRAD_EARLY_GRADUATION_ELIGIBILITY_FOR_COURSE', {
      courseId,
      eligibility,
    });
  },
};

export default actions;
